import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var AirSvg = function AirSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B30B00",
    d: "M20.333 2H3.667C2.747 2 2 2.746 2 3.667v16.666C2 21.253 2.746 22 3.667 22h16.666c.92 0 1.667-.746 1.667-1.667V3.667C22 2.747 21.254 2 20.333 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M16.81 14.027c-.032-.041-.08-.1-.134-.156a5 5 0 0 1-1.254-2.143q-.014-.054-.027-.109a4.96 4.96 0 0 1 .041-2.374s.03-.13.039-.185a1.982 1.982 0 0 0-3.83-.965c-.015.037-.043.13-.043.13a5 5 0 0 1-1.134 2.053 4.8 4.8 0 0 1-2.251 1.326 1.984 1.984 0 0 0 1.027 3.832c.789-.201 1.599-.225 2.374-.041l.109.028q.054.014.107.03a4.96 4.96 0 0 1 2.037 1.223c.071.071.133.122.19.163a1.986 1.986 0 0 0 2.614-.163 1.98 1.98 0 0 0 .134-2.65m-4.805.358a1.94 1.94 0 1 1 1.005-3.75 1.94 1.94 0 0 1-1.005 3.75",
    clipRule: "evenodd"
  }));
};
export var Air = function Air(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: AirSvg
  }));
};